import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import type { TariffPeriodForDropdown } from '@innogy/become-a-customer/shared/interfaces';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrustedHtmlPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'ed-commodity-vertical-offer-dropdown-table',
  templateUrl: './commodity-vertical-offer-dropdown-table.component.html',
  styleUrls: ['./commodity-vertical-offer-dropdown-table.component.scss'],
  standalone: true,
  imports: [CommonModule, TrustedHtmlPipe, AutomationIdDirective],
})
export class CommodityVerticalOfferDropdownTableComponent {
  readonly energyTitle = input<string>();
  readonly fixedRedeliveryTitle = input<string>();
  readonly fixedDeliveryCostLabel = input<string>();
  readonly fixedRedeliveryCostLabel = input<string>();
  readonly fixedDeliveryCostValue = input<number>();
  readonly fixedRedeliveryCostValue = input<number>();
  readonly fixedRedeliveryCostScaleValue = input<string>();
  readonly tariffPeriods = input<TariffPeriodForDropdown[]>();
  readonly dynamicPricingExpectedDeliveryRateTitle = input<string>();
}
